import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const ContractService = {
    async requestaccess(document_type) {
        try {
            const result = await axios.post(`${apiUrl}/contract/requestaccess/`,
                {
                    "document_type": document_type
                });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
     async verifyandview(document_type,pinCode) {
        try {
            const result = await axios.post(`${apiUrl}/contract/verifyandview/`,
                {
                    "document_type": document_type,
                    "code":pinCode
                });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
     async gethistory(stagiaire_id) {
        try {
            const result = await axios.get(`${apiUrl}/contract/gethistory/`+stagiaire_id);
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
     async actionacces(stagiaire_id,document_type,action) {
        try {
            const result = await axios.post(`${apiUrl}/contract/actionacces/`,
                {
                    "stagiaire_id": stagiaire_id,
                    "document_type": document_type,
                    "action":action
                });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async uploadattestation(formData) {
     return  await axios.post(`${apiUrl}/contract/uploadscontrat`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      },
      );
  },
  async detailuser(id) {
     return  await axios.get(`${apiUrl}/contract/detailsuser/`+id, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      },
      );
  },
  async listusers(direction,service,matricule,nom) {
     try {
            const result = await axios.post(`${apiUrl}/contract/listusers/`,
                {
                    "direction": direction,
                    "service": service,
                    "matricule":matricule,
                    "nom":nom
                });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
  },
  async getdetailsaffectation(id=null)
  {
    try {
            const result = await axios.get(`${apiUrl}/contract/getDetailsAffectation/`+id);
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
  },
}
export default ContractService;
